import * as Types from '../../../gql/types';

import {gql} from '@apollo/client';
import {PosterDetailsFragmentDoc} from '../../../gql/fragments/poster-details';
import {PosterOptionsFragmentDoc} from '../../../gql/fragments/poster-options';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type EditorQueryVariables = Types.Exact<{
  posterId: Types.Scalars['ID']['input'];
  hasPosterId: Types.Scalars['Boolean']['input'];
}>;

export type EditorQuery = {
  __typename?: 'Query';
  me: {
    __typename?: 'User';
    preview: {
      __typename?: 'Poster';
      id: string;
      name: string;
      variant: Types.PosterVariant;
      activitiesStartDate: any;
      activitiesEndDate: any;
      activityTypes: Array<Types.ActivityType>;
      baseColor: any;
      highlightColor: any;
      image: {__typename?: 'Image'; url: any};
      options: {
        __typename?: 'PosterOptions';
        activityTypes: Array<Types.ActivityType>;
        colors: Array<any>;
      };
    };
    poster?: {
      __typename?: 'Poster';
      id: string;
      name: string;
      variant: Types.PosterVariant;
      activitiesStartDate: any;
      activitiesEndDate: any;
      activityTypes: Array<Types.ActivityType>;
      baseColor: any;
      highlightColor: any;
      image: {__typename?: 'Image'; url: any};
      options: {
        __typename?: 'PosterOptions';
        activityTypes: Array<Types.ActivityType>;
        colors: Array<any>;
      };
    };
  };
  editor: {__typename?: 'Editor'; posterVariants: Array<Types.PosterVariant>};
};

export const EditorDocument = gql`
  query editor($posterId: ID!, $hasPosterId: Boolean!) {
    me {
      preview {
        ...posterDetails
        image(transform: ORIGINAL) {
          url
        }
        ...posterOptions
      }
      poster(posterId: $posterId) @include(if: $hasPosterId) {
        ...posterDetails
        image(transform: ORIGINAL) {
          url
        }
        ...posterOptions
      }
    }
    editor {
      posterVariants
    }
  }
  ${PosterDetailsFragmentDoc}
  ${PosterOptionsFragmentDoc}
`;

/**
 * __useEditorQuery__
 *
 * To run a query within a React component, call `useEditorQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditorQuery({
 *   variables: {
 *      posterId: // value for 'posterId'
 *      hasPosterId: // value for 'hasPosterId'
 *   },
 * });
 */
export function useEditorQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    EditorQuery,
    EditorQueryVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useQuery<EditorQuery, EditorQueryVariables>(
    EditorDocument,
    options
  );
}
export function useEditorLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    EditorQuery,
    EditorQueryVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useLazyQuery<EditorQuery, EditorQueryVariables>(
    EditorDocument,
    options
  );
}
export function useEditorSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    EditorQuery,
    EditorQueryVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useSuspenseQuery<EditorQuery, EditorQueryVariables>(
    EditorDocument,
    options
  );
}
export type EditorQueryHookResult = ReturnType<typeof useEditorQuery>;
export type EditorLazyQueryHookResult = ReturnType<typeof useEditorLazyQuery>;
export type EditorSuspenseQueryHookResult = ReturnType<
  typeof useEditorSuspenseQuery
>;
export type EditorQueryResult = ApolloReactCommon.QueryResult<
  EditorQuery,
  EditorQueryVariables
>;
